<script setup lang="ts">
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/shad/ui/dialog'
import { Switch } from '@/components/shad/ui/switch'
import useFeatureFlagsStore from '@/composables/useFeatureFlags.store'
import getEnv from '@/util/env'
import { storeToRefs } from 'pinia'
import { onBeforeUnmount, onMounted, ref } from 'vue'

// composables
const featureFlags = useFeatureFlagsStore()
const { rbacEnforced } = storeToRefs(featureFlags)

// constants
const ENABLED = getEnv('VITE_APP_NODE_ENV') !== 'production'
const CHORD_WINDOW_MS = 500

// state
const open = ref(false)
const lastDAt = ref<number>(0)

// methods
function onKeyDown(event: KeyboardEvent) {
  // Ignore keystrokes typed into inputs so the chord doesn't hijack forms.
  const target = event.target as HTMLElement | null
  if (
    target &&
    (target.tagName === 'INPUT' ||
      target.tagName === 'TEXTAREA' ||
      target.isContentEditable)
  ) {
    return
  }
  if (
    !event.shiftKey ||
    event.ctrlKey ||
    event.metaKey ||
    event.altKey ||
    event.key.toLowerCase() !== 'd'
  ) {
    return
  }
  const now = performance.now()
  if (now - lastDAt.value < CHORD_WINDOW_MS) {
    open.value = true
    lastDAt.value = 0
    event.preventDefault()
  } else {
    lastDAt.value = now
  }
}

// lifecycle
onMounted(() => {
  if (!ENABLED) return
  window.addEventListener('keydown', onKeyDown)
})
onBeforeUnmount(() => window.removeEventListener('keydown', onKeyDown))
</script>

<template>
  <Dialog v-if="ENABLED" v-model:open="open">
    <DialogContent class="max-w-md">
      <DialogHeader>
        <DialogTitle>Developer menu</DialogTitle>
      </DialogHeader>
      <div class="flex items-center justify-between gap-4 py-2">
        <div class="font-medium">RBAC Enabled</div>
        <Switch v-model:checked="rbacEnforced" />
      </div>
    </DialogContent>
  </Dialog>
</template>
